import i18n from "@/i18n/index";
import { getTaskStatus } from "@/components/tasks/myTeamsTasks/constants";

const highestPriority = require("@/assets/images/highestPriority.svg");
const highPriority = require("@/assets/images/highPriority.svg");
const normalPriority = require("@/assets/images/normalPriority.svg");
const lowPriority = require("@/assets/images/lowPriority.svg");
const lowestPriority = require("@/assets/images/lowestPriority.svg");

export default {
    methods: {
        getTaskPriority(priority, addColor) {
            let priorityDetails = "mdi-minus";
            if (priority) {
                priorityDetails = addColor ? this.allTasksPriority[priority].color : this.allTasksPriority[priority].icon;
            }
            return priorityDetails;
        },
        getTaskPriorityImg(priority) {
            let priorityIcon = "";
            if (priority) {
                if (priority === "highest") {
                    priorityIcon = highestPriority;
                } else if (priority === "high") {
                    priorityIcon = highPriority;
                } else if (priority === "normal") {
                    priorityIcon = normalPriority;
                } else if (priority === "low") {
                    priorityIcon = lowPriority;
                } else if (priority === "lowest") {
                    priorityIcon = lowestPriority;
                }
            }
            return priorityIcon;
        },
        getTaskStatusColor(status) {
            const item = this.allTasksStatus.find(elem => (elem.id === status || elem.value === status));
            return item ? item.iconColor : "";
        },
        getCurrentStatus(status) {
            return getTaskStatus(status);
        },
        openDlg(data, actionType) {
            if (data) {
                if (actionType === "UNCLAIM") {
                    this.reassignAction = false;
                } else if (actionType === "REASSIGN") {
                    this.reassignAction = true;
                }
                this.currentSelectedTaskId = data;
            }
            this.bulkUnclaimReassignModal = true;
        },
        unclaimReassignModalClosed() {
            this.bulkUnclaimReassignModal = false;
        },
        openTask(data, canUnclaim) {
            const dataSettings = JSON.parse(JSON.stringify(data));
            const open = () => {
                const isMobile = localStorage.getItem("localIsSmallScreen");
                if (!this.bulkTypeSelected) {
                    dataSettings.__myTeamsFilters = this.tasksDisplayPayload;
                    if (this.activePage === "dashboard") {
                        dataSettings.__dashboard = true;
                        dataSettings.__teamDashboard = this.dashboardType === "team";
                        dataSettings.pageToSend = dataSettings.__teamDashboard ? "myteamsdashboard-" : "mydashboard-";
                        dataSettings.__readonly = this.dashboardType === "team";
                        dataSettings.__fromAdmin = true;
                        dataSettings.__isManager = true;
                    } else if (this.activePage === "tasks") {
                        dataSettings.__teamsTasks = false;
                        if (this.type === "completedTasks" || this.type === "completedTeamsTasks") {
                            dataSettings.__tasksCompleted = true;
                            dataSettings.pageTab = "completedTasks";
                            dataSettings.__teamsTasks = this.type === "completedTeamsTasks";
                            dataSettings.pageToSend = dataSettings.__teamsTasks ? "teamTasks-" : "myTasks-";
                            dataSettings.__readonly = true;
                            if (isMobile) {
                                if (this.type === "completedTasks") {
                                    localStorage.setItem("isCompleted", "completedTasks");
                                } else {
                                    localStorage.setItem("isCompleted", "completedTeamsTasks");
                                }
                            }
                        } else if (this.type === "myOpenTasks") {
                            dataSettings.__tasks = true;
                            dataSettings.pageTab = "todoTasks";
                            dataSettings.pageToSend = "myTasks-";
                        } else {
                            dataSettings.__teamsTasks = true;
                            dataSettings.pageTab = "todoTasks";
                            dataSettings.pageToSend = "teamTasks-";
                            dataSettings.__readonly = true;
                            dataSettings.__isManager = true;
                            dataSettings.__fromAdmin = true;
                            if (isMobile) {
                                localStorage.setItem("isCompleted", "openTeamsTasks");
                            }
                            dataSettings.reassignUserList = this.getReassignUserList;
                        }
                    }
                    if (this.showColSettings) {
                        dataSettings.columnsListToShow = this.columnsListToShow;
                    }
                    if (canUnclaim) {
                        dataSettings.canUnclaim = true;
                    }

                    const { pageToSend, pageTab, taskId } = dataSettings;
                    this.$router.push({ path: `/${pageToSend}${pageTab || "tasks"}/${taskId}` });
                }
            };
            if (this.type === "myOpenTasks") {
                this.$store.dispatch("components/claimTask", data.taskId).then(rsp => {
                    if (rsp) {
                        data.canUnclaim = rsp.data.canUnclaim;
                        open();
                    }
                });
            } else {
                open();
            }
        },
        refreshTasksDataList() {
            this.initialPageNumber = this.tasksDisplayPayload.pageNumber;
            this.initialPageSize = this.tasksDisplayPayload.pageSize;

            if (this.tasksDisplayPayload.pageNumber) {
                this.tasksDisplayPayload.pageSize *= this.tasksDisplayPayload.pageNumber + 1;
                this.tasksDisplayPayload.pageNumber = 0;
            }
            if (!this.nameValue) {
                this.tasksDisplayPayload.type = this.type;
            }
            this.getAllTasks(false, true);
        },
        transformData(element) {
            return {
                taskName: element.taskName,
                processInstanceName: element.processInstanceName,
                creationDate: element.creationDate,
                timeRemaining: this.remainingTime(element.deadline),
                completionDate: element.completionDate,
                status: element.status,
                subject: element.subject,
                interface: element.processDefinitionName,
                claimedBy: element.claimedBy,
                isDelegated: element.isDelegated,
                priority: element.priority,
                delegatedTo: element.delegatedTo,
                delegatedFrom: element.delegatedFrom,
                data: element,
                taskId: element.taskId,
                taskType: element.taskType,
                canUnclaim: element.canUnclaim,
                canReassign: element.canReassign,
                users: element.users,
                groups: element.groups,
                guiId: element.guiId,
                processInstanceId: element.processInstanceId,
                processDefinitionId: element.processDefinitionId,
                activityId: element.activityId
            };
        },
        remainingTime(deadline) {
            const deadlineTime = new Date(deadline);
            const currentTime = new Date();
            const difference = deadlineTime.getTime() - currentTime.getTime();
            const seconds = Math.floor(difference / 1000);
            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);
            let days = Math.floor(hours / 24);
            const weeks = Math.floor(days / 7);
            let extHour = 0 + i18n.t("appTasksContainer.minutes");
            if (hours > 0) {
                extHour = hours + i18n.t("appTasksContainer.hours");
            } else if (minutes > 1) {
                extHour = minutes + i18n.t("appTasksContainer.minutes");
            } else if (minutes > 0 && minutes <= 1) {
                extHour = i18n.t("appTasksContainer.critical");
            }

            hours %= 24;
            minutes %= 60;
            days %= 7;
            let remainingTime = extHour;
            if (weeks >= 1) {
                remainingTime = `${weeks + i18n.t("tasks.weeks")}, ${days}${i18n.t("appTasksContainer.days")}`;
            } else if (days >= 1) {
                remainingTime = `${days + i18n.t("tasks.days")}, ${hours}${i18n.t("appTasksContainer.hours")}`;
            } else if (hours > 0) {
                remainingTime = extHour + (minutes ? `, ${minutes}${i18n.t("appTasksContainer.minutes")}` : "");
            }
            return remainingTime;
        }
    }
};
